import { render, staticRenderFns } from "./ReglasUso.vue?vue&type=template&id=16866c82&scoped=true"
import script from "./ReglasUso.vue?vue&type=script&lang=js"
export * from "./ReglasUso.vue?vue&type=script&lang=js"
import style0 from "./ReglasUso.vue?vue&type=style&index=0&id=16866c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16866c82",
  null
  
)

export default component.exports